import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { Council, GeoCodingID, GeocodingResult } from '../models/GeoCoding';

export default class GeocodingApi {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async geocodingSearch(filter: string): Promise<GeoCodingID[]> {
        const result = await this.http.get(`/abacoGeocodingRest/api_basic/v1/geocoding/results?search=${filter}`);
        return result.data;
    }

    public async geocodingPosition(id: string): Promise<GeocodingResult> {
        const result = await this.http.get(`/abacoGeocodingRest/api_basic/v1/geocoding/results/${id}`);
        return result.data;
    }

    public async getCurCouncil(coord: number[]): Promise<Council | null> {
        const url = `/sitiagri-rest-api/api_basic/v1/plots/dictionary_councils`;
        const params = {
            long: coord[0],
            lat: coord[1],
        }
        const res = await this.http.get(url, {params});
        return res.data.records && res.data.records.length ? res.data.records[0] : null;
    }

}
